import type { ReactNode } from "react";

interface DetailFieldProps {
  label: string;
  children: ReactNode;
}

export function DetailField({ label, children }: DetailFieldProps) {
  return (
    <div className="space-y-1">
      <div className="eyebrow">{label}</div>
      <div>{children}</div>
    </div>
  );
}
